<!-- ======= Header ======= -->
<header id="header" class="fixed-top header-transparent">
  <div class="container d-flex align-items-center justify-content-between">
    <div class="logo">
      <a
        ><img
          [src]="coloredLogoUrl"
          alt=""
          class="img-fluid"
      /></a>
    </div>

    <nav id="navbar" class="navbar">
      <ul>
        <li>
          <a class="nav-link" [routerLink]="['/faq/AboutValueCapital']">{{
            "Footer.ABOUT" | translate}} {{'Tenant.Company_Name' | translate}}</a>
        </li>
        <!-- <li><a class="nav-link" [routerLink]="['/opportunities/opportunity-list']">{{ 'OPPORTUNITIES' | translate }}</a></li> -->
        <li>
          <a class="nav-link" [routerLink]="['/faq/FAQ']">{{
            "General.FAQ" | translate
          }}</a>
        </li>
        <li>
          <a class="nav-link" [routerLink]="['/faq/SupportAndHelp']">{{
            "General.CONTACT_US" | translate
          }}</a>
        </li>
      </ul>
      <ul>
        <li>
          <a class="nav-link" (click)="languageService.switchLang('en')">{{
            "EN" | translate
          }}</a>
        </li>
        <li>|</li>
        <li>
          <a class="nav-link" (click)="languageService.switchLang('ar')">{{
            "AR" | translate
          }}</a>
        </li>
        <li>
          <button  [routerLink]="['/authentication/login']">{{
            "General.GET_STARTED" | translate
          }}</button>
        </li>
      </ul>
      <i class="bi bi-list mobile-nav-toggle"></i>
    </nav>
    <!-- .navbar -->
  </div>
</header>
<!-- End Header -->

<!-- ======= Hero Section ======= -->
<section id="hero" class="d-flex align-items-center">
  <div class="container">
    <div class="row">
      <div
        class="col-lg-6 d-lg-flex flex-lg-column align-items-stretch order-2 order-lg-1 hero-img"
      >
        <img
          [src]="homeMobileAppSplashImageUrl"
          class="img-fluid"
          alt=""
        />
      </div>
      <div
        class="col-lg-6 d-lg-flex flex-lg-column justify-content-center align-items-stretch pt-5 pt-lg-0 order-1 order-lg-2"
      >
        <div>
          <h1>
            <span class="secondary_color hero_sec_title">{{'Tenant.Company_Name' | translate}}</span
            ><br />
            {{ "Home.FINANCIAL_FUTURE_EASILY" | translate }}
          </h1>
          <h2>{{ "Home.LOREM_IPSUM_DESCRIPTION" | translate }}</h2>
          <h4>{{ "Home.DOWNLOAD_APP_NOW" | translate }}</h4>

          <div class="row">
            <div class="col-6 col-lg-4">
              <a href="{{googlePlayDownloadUrl}}">
                <img
                  src="../../../assets/images/google-play-black.png"
                  alt=""
                  class="img-fluid"
                />
              </a>
            </div>
            <div class="col-6 col-lg-4">
              <a href="{{appleStoreDownloadUrl}}">
                <img
                  src="../../../assets/images/store-apple-app-black.png"
                  alt=""
                  class="img-fluid"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Hero -->

<main id="main">
  <!-- ======= App Features Section ======= -->
  <section id="features" class="features">
    <div class="container">
      <div class="section-title">
        <h2>{{ "Home.OUR_FEATURES" | translate }}</h2>
      </div>

      <div class="row">
        <div class="col-lg-12 align-items-center">
          <div class="content justify-content-center">
            <div class="row">
              <div class="col-md-6 mb-1">
                <div class="icon-box align-items-center d-flex">
                  <i class="ri-money-dollar-circle-line"></i>
                  <h4>
                    {{ "Home.MULTIPLE_INVESTMENT_OPPORTUNITIES" | translate }}
                  </h4>
                </div>
              </div>

              <div class="col-md-6 mb-1">
                <div class="icon-box align-items-center d-flex">
                  <i class="ri-magic-line"></i>
                  <h4>{{ "Home.SIMPLE_EASY_REGISTRATION" | translate }}</h4>
                </div>
              </div>

              <div class="col-md-6 mb-1">
                <div class="icon-box align-items-center d-flex">
                  <i class="ri-command-fill"></i>
                  <h4>{{ "Home.FOR_ALL" | translate }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- End App Features Section -->

  <!-- ======= Opportunities Section ======= -->

  <section id="Opportunities" class="Opportunities">
    <div class="container">
      <div class="d-flex align-items-center justify-content-between">
      <div class="section-title">
        <h1>{{ "Opportunities.OPPORTUNITIES" | translate }}</h1>
      </div>
      <button *ngIf="opportunityTheme==opportunityThemes.MODERN" (click)="openFilterDialog()">{{ "Shared.FILTER" | translate }}
        <i class="ri-filter-line"></i>
      </button>
      </div>
      <div  *ngIf="opportunityTheme==opportunityThemes.CLASSIC">
      <nav id="navbar" class="navbar">
        <div class="navbar_items">
          <ul>
            <li>
              <a class="nav-link menu_links cursor-pointer" [ngClass]="{ active: filterFundStatus == fundStatus.Current }"
                (click)="filter(fundStatus.Current)">{{ "Opportunities.Current" | translate }}</a>
            </li>
            <li>
              <a class="nav-link menu_links cursor-pointer" [ngClass]="{ active: filterFundStatus == fundStatus.Upcoming }"
                (click)="filter(fundStatus.Upcoming)">{{ "Opportunities.Upcoming" | translate }}</a>
            </li>
            <li>
              <a class="nav-link menu_links cursor-pointer" [ngClass]="{ active: filterFundStatus == fundStatus.Ended }"
                (click)="filter(fundStatus.Ended)">{{ "Opportunities.Ended" | translate }}</a>
            </li>
          </ul>
        </div>
      </nav> 
      <nav id="navbar" class="navbar mt-4">
        
        <div class="navbar_items">
          <ul>
            <li>
              <a
              class="nav-link menu_links cursor-pointer"
              [ngClass]="{ active: !filterFundType }"
              (click)="filter(filterFundStatus)"
              >{{ "Shared.ALL" | translate }}</a>
            </li>
            <li>
              <a
              class="nav-link menu_links cursor-pointer"
              [ngClass]="{ active: filterFundType == fundTypes.OpenFund }"
              (click)="filter(filterFundStatus,fundTypes.OpenFund)"
              >{{ "Home.Open Fund" | translate }}</a
            >
  
            </li>
            <li>
              <a
              class="nav-link menu_links cursor-pointer"
              [ngClass]="{ active: filterFundType == fundTypes.CloseFund }"
              (click)="filter(filterFundStatus,fundTypes.CloseFund)"
              >{{ "Home.Closed Fund" | translate }}</a
            >
            </li>
          </ul>
        </div>
      </nav>
    </div>
      <div class="row gy-4 mt-1 mt-sm-2 mt-md-3 mt-lg-4" *ngIf="opportunities.length">
        <div [ngClass]="opportunityTheme === opportunityThemes.MODERN ? 'col-12 col-md-6 col-lg-4 mb-2' : 'col-12 col-md-6 mb-2'" *ngFor="let item of opportunities">
          <app-opportunity-card [opportunity]="item" [filterFundStatus]="selectedFilterFundStatus"></app-opportunity-card>
        </div>
      
      </div>
      <div *ngIf="opportunities.length==0"
        class="w-100 d-flex align-items-center justify-content-center">
        <div class="text-center">
          <img [src]="'assets/images/'+tenantId+'/No data-cuate 1.svg'" />
          <h2>{{ "Opportunities.NO_DATA" | translate }}</h2>
          
        </div>
  
      </div>
  
    </div>
  </section>

  <!-- End Opportunities Section -->
</main>
<!-- End #main -->
<ng-template #filterDialogRef >
  <div class="h-100 p-4 d-flex flex-column align-items-center justify-content-between">
    <div>
      <div class="section-title mt-5">
        <p class="font-size-3">{{ "Opportunities.FILTER_BY_FUND_STATUS" | translate }}</p>
      </div>
  <nav id="navbar" class="navbar mb-4">
    <div class="navbar_items">
      <ul>
        <li>
          <a class="nav-link menu_links cursor-pointer" [ngClass]="{ active: filterFundStatus == fundStatus.Current }"
            (click)="setFilter(fundStatus.Current)">{{ "Opportunities.Current" | translate }}</a>
        </li>
        <li>
          <a class="nav-link menu_links cursor-pointer" [ngClass]="{ active: filterFundStatus == fundStatus.Upcoming }"
            (click)="setFilter(fundStatus.Upcoming)">{{ "Opportunities.Upcoming" | translate }}</a>
        </li>
        <li>
          <a class="nav-link menu_links cursor-pointer" [ngClass]="{ active: filterFundStatus == fundStatus.Ended }"
            (click)="setFilter(fundStatus.Ended)">{{ "Opportunities.Ended" | translate }}</a>
        </li>
      </ul>
    </div>
  </nav> 
  <div class="section-title mt-5">
    <p class="font-size-3">{{ "Opportunities.FILTER_BY_FUND_TYPE" | translate }}</p>
  </div>
  <nav id="navbar" class="navbar mt-4">
    
    <div class="navbar_items">
      <ul>
        <li>
          <a
          class="nav-link menu_links cursor-pointer"
          [ngClass]="{ active: !filterFundType }"
          (click)="setFilter(filterFundStatus)"
          >{{ "Shared.ALL" | translate }}</a>
        </li>
        <li>
          <a
          class="nav-link menu_links cursor-pointer"
          [ngClass]="{ active: filterFundType == fundTypes.OpenFund }"
          (click)="setFilter(filterFundStatus,fundTypes.OpenFund)"
          >{{ "Home.Open Fund" | translate }}</a
        >

        </li>
        <li>
          <a
          class="nav-link menu_links cursor-pointer"
          [ngClass]="{ active: filterFundType == fundTypes.CloseFund }"
          (click)="setFilter(filterFundStatus,fundTypes.CloseFund)"
          >{{ "Home.Closed Fund" | translate }}</a
        >
        </li>
      </ul>
    </div>
  </nav>
</div>
<div class="w-100">
  <button class="btn-block" (click)="applyFilter()">{{ "Shared.FILTER" | translate }}</button>
  <button class="secondary-btn btn-block" (click)="closeFilterDialog()">{{ "Shared.CLOSE" | translate }}</button>
</div>
</div>
</ng-template>
